const points = (() => {
  const pts = [];
  for (let i = 0; i <= 360 * 3.1; i += 5) {
    const a = (i * Math.PI) / 180;
    const r = 1.5 + a * 2.25;
    pts.push(`${(50 + r * Math.cos(a)).toFixed(2)},${(50 + r * Math.sin(a)).toFixed(2)}`);
  }
  return pts.join(" ");
})();

export const Sigil = ({ size = 40, className = "", color = "#020303", stroke = 4.5 }) => (
  <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden>
    <polyline points={points} fill="none" stroke={color} strokeWidth={stroke} strokeLinecap="round" strokeLinejoin="round" />
    <path d="M92 50 C 96 62, 90 74, 97 86 M50 94 C 40 97, 34 92, 24 97 M8 46 C 3 36, 8 26, 2 16"
      fill="none" stroke={color} strokeWidth={stroke * 0.45} strokeLinecap="round" />
  </svg>
);
